import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`font-mono-alt text-[11px] sm:text-xs uppercase tracking-[0.35em] mb-5 ${
      dark ? "text-[#a8824f]" : "text-[#b08a58]"
    }`}
  >
    {children}
  </p>
);
